import { render, staticRenderFns } from "./LandingAbout.vue?vue&type=template&id=da9565e4&scoped=true"
import script from "./LandingAbout.vue?vue&type=script&lang=js"
export * from "./LandingAbout.vue?vue&type=script&lang=js"
import style0 from "./LandingAbout.vue?vue&type=style&index=0&id=da9565e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9565e4",
  null
  
)

export default component.exports